import React, { useEffect } from 'react';
import rulebookPdf from '@/assets/MASTER_RESUME_WRITING_RULEBOOK.pdf';

export default function ResumeWritingRulebook() {
  useEffect(() => {
    // Navigate directly to the PDF so the browser renders it natively
    window.location.replace(rulebookPdf);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="text-center">
        <p className="mb-3">Opening PDF…</p>
        <a href={rulebookPdf}>Open PDF</a>
      </div>
    </div>
  );
}
